import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import custUsersServices from '@src/services/custUsers.services';
import usersServices from '@src/services/users.services';

export const custUsersGetUserList = createAsyncThunk(
  'custUsersGetUserList',
  async ({ body, pageNumber, pageSize, type }, { rejectWithValue }) => {
    try {
      const result = await custUsersServices.getCustomerUserList({ body, pageNumber, pageSize });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const custUsersGetList = createAsyncThunk(
  'custUsersGetList',
  async ({ body, pageNumber, pageSize, type }, { rejectWithValue }) => {
    try {
      const result = await custUsersServices.getCustomerList({ body, pageNumber, pageSize });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const userByFilterList = createAsyncThunk(
  'userByFilterList',
  async ({ body, pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      const result = await custUsersServices.getCustomerUserByFilterList({
        body,
        pageNumber,
        pageSize,
      });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const custUserDelete = createAsyncThunk(
  'custUserDelete',
  async (id, { rejectWithValue }) => {
    try {
      const result = await usersServices.userSoftDelete({ userId: id });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const custUserStatusChange = createAsyncThunk(
  'custUserStatusChange',
  async ({ body }, { rejectWithValue }) => {
    try {
      const result = await usersServices.userChangeStatus(body);
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  filter: {
    custUsersList: [],
    tableProperty: {
      currentPage: 1,
      page: 1,
      pageSize: 10,
      totalCount: 0,
    },
    filterObject: {
      body: [],
      pageNumber: 1,
      pageSize: 10,
    },
  },
  table: {
    detail: null,
    tableProperty: {
      currentPage: 1,
      page: 1,
      pageSize: 10,
      totalCount: 0,
    },
    filterObject: {
      body: [],
      pageNumber: 1,
      pageSize: 10,
    },
  },
  filterObject: {},
};

export const custUsersSlice = createSlice({
  name: 'custUsers',
  initialState,
  reducers: {
    clearCustUsers(state) {
      state.filter = { ...state.filter, custUsersList: [] };
      state.table = { ...state.table, detail: null };
    },
    clearTable(state) {
      state.table = { ...state.table, detail: null };
    },
    setFilterObject: (state, action) => {
      state.filterObject = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(custUsersGetList.fulfilled, (state, action) => {
      state.filter.custUsersList = action?.payload?.data?.items || [];
      state.filter.tableProperty =
        action?.payload?.data?.pagedProperty || initialState?.table?.tableProperty;
    });
    builder.addCase(custUsersGetUserList.fulfilled, (state, action) => {
      state.table.detail = action?.payload?.data;
      state.table.tableProperty = action?.payload;
    });
    builder.addCase(userByFilterList.fulfilled, (state, action) => {
      state.table.detail = {
        customerUsers: {
          items: action.payload.data.customerUsers
        }
      }
      state.table.tableProperty = action?.payload || initialState?.table?.tableProperty;
    });
  },
});

export const { clearCustUsers, clearTable, setFilterObject } = custUsersSlice.actions;
